import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from "@gettactic/components";
import {
  ArrowDown,
  ArrowUp,
  Crosshair,
  Group,
  MoreVertical,
  Square,
  Trash2,
  Ungroup
} from "lucide-react";
import React from "react";
import { IconButton } from "./ui/IconButton";

interface LayerActionsProps {
  onDelete?: () => void;
  onLocate?: () => void;
  onMoveUp?: () => void;
  onMoveDown?: () => void;
  onUngroup?: () => void;
  onGroup?: () => void;
  onUpdateEditingArea?: () => void;
}

export const LayerActions: React.FC<LayerActionsProps> = ({
  onDelete,
  onLocate,
  onMoveUp,
  onMoveDown,
  onGroup,
  onUngroup,
  onUpdateEditingArea
}) => {
  const handleAction = (action: () => void) => {
    action();
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <IconButton size="sm" label="More actions" hasTooltip={false}>
          <MoreVertical size={16} />
        </IconButton>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuGroup>
          {onMoveUp && (
            <DropdownMenuItem
              className={"gap-2 text-neutral-700"}
              onClick={(e) => {
                e.stopPropagation();
                handleAction(onMoveUp);
              }}
            >
              <ArrowUp size={14} className="text-neutral-500" />
              Move Up
            </DropdownMenuItem>
          )}
          {onMoveDown && (
            <DropdownMenuItem
              className={"gap-2 text-neutral-700"}
              onClick={(e) => {
                e.stopPropagation();
                handleAction(onMoveDown);
              }}
            >
              <ArrowDown size={14} className="text-neutral-500" />
              Move Down
            </DropdownMenuItem>
          )}
          {onLocate && (
            <DropdownMenuItem
              className={"gap-2 text-neutral-700"}
              onClick={(e) => {
                e.stopPropagation();
                handleAction(onLocate);
              }}
            >
              <Crosshair size={14} className="text-neutral-500" />
              Locate
            </DropdownMenuItem>
          )}
          {onDelete && (
            <DropdownMenuItem
              className={"gap-2 text-red-600"}
              onClick={(e) => {
                e.stopPropagation();
                handleAction(onDelete);
              }}
            >
              <Trash2 size={14} className="text-red-600" />
              Delete
            </DropdownMenuItem>
          )}
          {onGroup && (
            <>
              <DropdownMenuSeparator />
              <DropdownMenuItem
                className={"gap-2 text-neutral-700"}
                onClick={(e) => {
                  e.stopPropagation();
                  handleAction(onGroup);
                }}
              >
                <Group size={14} className="text-neutral-500" />
                Group items
              </DropdownMenuItem>
            </>
          )}
          {onUngroup && (
            <>
              <DropdownMenuSeparator />
              <DropdownMenuItem
                className={"gap-2 text-neutral-700"}
                onClick={(e) => {
                  e.stopPropagation();
                  handleAction(onUngroup);
                }}
              >
                <Ungroup size={14} className="text-neutral-500" />
                Ungroup
              </DropdownMenuItem>
            </>
          )}
          {onUpdateEditingArea && (
            <>
              <DropdownMenuSeparator />
              <DropdownMenuItem
                className={"gap-2 text-neutral-700"}
                onClick={(e) => {
                  e.stopPropagation();
                  handleAction(onUpdateEditingArea);
                }}
              >
                <Square size={14} className="text-neutral-500" />
                Update editing area
              </DropdownMenuItem>
            </>
          )}
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
